import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Nav from '../components/Nav';

import Loading from '../components/Loading';
import Options from '../components/customization/options';
import ProductGroups from '../components/customization/ProductGroups';
import TotalContainer from '../components/TotalContainer';
import stepAnalytics from '../utils/stepAnalytics';
import Help from '../components/help/Help';

class PrintSelection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      totalContainerLink: '/revieworder/',
      totalContainerLinkText: this.props.generalTranslations.Review_Order,
      optionVisible: true
    };
  }

  componentDidMount() {
    stepAnalytics('/print', 'print', 'step 3');
    window.scrollTo(0, 0);
    window.addEventListener('scroll', this.handleScroll);
    this.props.getCustomizationTranslations();
    this.props.updateAlert('customization');

    if (this.props.settings.groupType === 'club') {
      this.setState({
        optionVisible: false
      });
    }
  }

  componentWillUnmount() {
    this.props.postCustomization(
      this.props.customizations,
      this.props.customizationItems
    );
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = () => {
    if (window.pageYOffset > 175) {
      this.setState({ totalContainerSticky: true });
    } else {
      this.setState({ totalContainerSticky: false });
    }
  };

  toggleHelpAlert = () => {
    this.props.toggleHelp();
  };

  render() {
    return (
      <div>
        <Nav />

        {this.props.helpShown && (
          <Help
            toggleAlert={this.toggleHelpAlert}
            path={this.props.match.path}
          />
        )}

        {this.props.customizations && this.props.customizations.length > 0 ? (
          <div className="teamsport_content">
            <div className="main_container">
              <div className="generalOptions">
                <div className="titleContent">
                  <span className="titleText">
                    {this.props.generalTranslations.Print_Options}
                  </span>
                  <div
                    className="helpButton"
                    onClick={this.toggleHelpAlert}
                    role="button"
                    tabIndex="0"
                    style={{ outline: 'none' }}
                  >
                    {this.props.generalTranslations.NeedHelp}
                  </div>
                </div>
                {this.state.optionVisible && <Options />}
              </div>
              <div className="individualOptions">
                <ProductGroups
                  customizations={this.props.customizations}
                  currency={this.props.currency}
                />
              </div>
            </div>
            <TotalContainer
              totalContainerSticky={this.state.totalContainerSticky}
              totalContainerLink={this.state.totalContainerLink}
              totalContainerLinkText={this.state.totalContainerLinkText}
              previewImageVisible
            />
          </div>
        ) : (
          <Loading />
        )}
      </div>
    );
  }
}
const mapDispatch = dispatch => ({
  postCustomization: (customizations, customizationItems) =>
    dispatch({
      type: 'POST_CUSTOMIZATION',
      customizations,
      customizationItems
    }),
  getCustomizationTranslations: () =>
    dispatch({
      type: 'GET_COSTUMIZATION_TRANSLATIONS'
    }),
  updateAlert: alertElement =>
    dispatch({
      type: 'UPDATE',
      alertElement
    }),
  toggleHelp: () =>
    dispatch({
      type: 'TOGGLE_HELP'
    })
});

const mapState = state => ({
  customizations: state.customizations,
  customizationItems: state.customizationItems,
  total: state.total,
  settings: state.settings,
  generalTranslations: state.generalTranslations,
  costumizationToggleItems: state.costumizationToggleItems,
  helpShown: state.helpShown
});

export default withRouter(connect(mapState, mapDispatch)(PrintSelection));
